module.exports = __webpack_public_path__ + "img/whatapp-c.e1cfeb1.png";